import styled from "@emotion/styled";

const Icon = ({ className }: { className?: string }) => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <circle cx="13" cy="13" r="13" />
    <path d="M6 10H20" />
    <path d="M14 18H12" />
    <path d="M17 14L9 14" />
  </svg>
);

export const FilterIcon = styled(Icon)<{ filterSelected: boolean }>`
  path {
    stroke-width: 1.5px;
    stroke-linecap: round;
    stroke: ${({ filterSelected, theme }) =>
      filterSelected ? theme.colors.snowdrop : theme.colors.charcoal};
  }
  fill: ${({ filterSelected, theme }) =>
    filterSelected ? theme.colors.forestLight : theme.colors.snowdrop};
  :hover {
    fill: ${({ filterSelected, theme }) =>
      filterSelected ? theme.colors.forest : theme.colors.mistDark};
  }
`;
